import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import IconButton from '@mui/material/IconButton';
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import {logger} from '../utils';

export default function DayDeleteDialog({ handleDeleteCallback, data}) {
    const [open, setOpen] = React.useState(false);

    const onTrigger = React.useCallback(() => {
        const msg = {
            ID: data.ID
        };
        handleDeleteCallback(msg)
        handleClose();
      })

    const handleClickOpen = () => {
        logger(data)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Delete Entry" placement="top-end">
            <IconButton
                variant="contained"
                onClick={handleClickOpen}
                disabled={data.IsLocked === 1}
            >
                <DeleteForeverRoundedIcon color={data.IsLocked === 1 ? "disabled" : "primary"}/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="alert-dialog-title">
                    {" Delete Confirm"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        <p><b>Task:</b> {data.Task} {moment(data.DayOf).format('MM/DD/YYYY')}</p>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Disagree</Button>
                    <Button onClick={onTrigger}>Agree</Button>
                    </DialogActions>
            </Dialog>
        </div>
    );
}